<template>
  <div>
    <ListingLayout
      :is-loading="isLoading"
      :meta="meta"
      :headers="_headers"
      :items="list"
      :filter-names="filterNames"
      show-date
      search-label="search"
      @filterOption="onFiltersChange"
    >
      <template v-slot:actions="{ item }">
        <v-icon
          v-if="isView"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-eye
        </v-icon>
        <v-icon
          v-if="isEdit"
          class="mr-2"
          small
          @click="editItem(item)"
        >
          mdi-pencil
        </v-icon>
        <v-icon
          v-if="isDelete"
          class="mr-2"
          small
          @click="deleteItem(item)"
        >
          mdi-delete
        </v-icon>
      </template>

      <!-- add Filters -->
      <template #addFilters>
        <v-card>
          <v-select
            v-model="customFilters.category_id"
            filled
            dense
            :loading="isCategory"
            :items="(options.tenant_id || options.fleetId) && categoryList"
            item-value="id"
            item-text="name"
            :label="$t('category')"
            @change="fetchData"
          />
        </v-card>
      </template>
      <!-- add Filters -->

      <!-- Action Modals -->
      <template #actionModals>
        <div>
          <create-inventory
            v-if="isCreate"
            :filter-options="options"
          />

          <edit-inventory
            v-if="(isEdit || isView) && editModal"
            :is-view="isView"
            :is-visible-dialog="editModal"
            :toggle-edit="toggleEditModal"
            :item="selectedRow"
          />
          <confirmation-modal
            v-if="isDelete"
            :is-visible="deleteModal"
            :toggle="toggleDeleteModal"
            :row="selectedRow"
          />
        </div>
      </template>
      <!-- Action Modals -->
    </ListingLayout>
  </div>
</template>

<script>
import { ListingLayoutMixins } from "@/mixins/ListingLayoutMixins";
import { mapGetters } from "vuex";
// import { debounce } from "lodash";
export default {
  components: {
    ListingLayout: () => import("@/layouts/section/ListingLayout.vue"),
    CreateInventory: () => import("./dialogs/CreateInventory.vue"),
    EditInventory: () => import("./dialogs/EditInventory.vue"),
    ConfirmationModal: () =>
      import("@/components/Modals/ConfirmationModal.vue"),
  },
  mixins: [ListingLayoutMixins],

  data() {
    return {
      // module_name: "csmsChargeStations", //vuex module name which define in Store Index
      permissions: {
        view: "inventory.view",
        create: "inventory.create",
        edit: "inventory.edit",
        delete: "inventory.delete",
      },
      //
      customFilters: {},
      //
      filters: {},
      subFilters: {},
    };
  },
  computed: {
    ...mapGetters({
      authUser: "getUser",
      isLoading: "inventory/getLoading",
      meta: "inventory/getMeta",
      list: "inventory/getList",
      //
      isCategory: "category/getLoading",
      categoryList: "category/getList",
    }),
    _headers() {
      const headers = [
        {
          text: this.$t("id"),
          align: "left",
          sortable: true,
          value: "id",
        },

        {
          text: this.$t("part"),
          align: "left",
          sortable: false,
          value: "part_name",
        },
        {
          text: this.$t("category"),
          align: "left",
          sortable: false,
          value: "category_name",
        },

        {
          text: this.$t("total_stock"),
          align: "left",
          sortable: true,
          value: "purchase_count",
        },
        {
          text: this.$t("used_stock"),
          align: "left",
          sortable: true,
          value: "used_stock",
        },
        {
          text: this.$t("remaining_stock"),
          align: "left",
          sortable: true,
          value: "stock_count",
        },
        {
          text: this.$options.filters.currencyFormat(
            this.$t("single_unit_price"),
            this.authUser
          ),
          align: "left",
          sortable: true,
          value: "display_stock_price",
        },
        {
          text: this.$options.filters.currencyFormat(
            this.$t("total_cost"),
            this.authUser
          ),
          align: "left",
          sortable: true,
          value: "total_cost",
        },
        {
          text: this.$t("tenant_name"),
          align: "left",
          sortable: false,
          value: "tenant_name",
          showAdmin: true,
        },
        {
          text: this.$t("inventory_date"),
          align: "left",
          sortable: true,
          value: "inventory_date",
        },
        // ...(this.authUser.user_nature == "fleet"
        //   ? [
        //       {
        //         text: this.$t("manufacturer"),
        //         align: "left",
        //         sortable: false,
        //         value: "tenant_name",
        //       },
        //     ]
        //   : []),

        ...(this.isView || this.isEdit || this.isDelete
          ? [
              {
                text: this.$t("actions"),
                align: "left",
                sortable: false,
                value: "actions",
              },
            ]
          : []),
      ];

      // computed headers for showing columns to role based
      return headers.filter(
        (header) =>
          header.showAdmin === undefined ||
          (header.showAdmin != undefined &&
            header.showAdmin === this.authUser.isAdmin)
      );
    },

    filterNames() {
      return [];
      // return ["single_vehicle", "customer"];
      // if (this.authUser.isAdmin) {
      // } else {
      //   return [];
      // }
    },
  },
  watch: {
    "options.tenant_id": {
      handler: function (v) {
        this.getCategory(v);
      },
    },
    "options.fleetId": {
      handler: function (v) {
        this.getCategory(v);
      },
    },
    options() {
      this.fetchData();
    },
  },
  beforeDestroy() {
    const params = {
      name: "inventory",
      filters: this.options,
    };
    this.$store.commit("redirect/SET_FILTERS", params);
  },
  mounted() {},
  methods: {
    async fetchData() {
      const params = { ...this.options, ...this.customFilters };
      await this.$store.dispatch("inventory/list", params).then(() => {
        if (this.options.page > (this.meta?.lastPage || 1)) {
          this.options.page = 1;
        }
      });
    },

    //
    getCategory(v) {
      if (v) {
        const params = {
          product: this.options.product,
          tenant_id: this.options.tenant_id,
          fleetId: this.options.fleetId,
        };
        this.$store.dispatch("category/list", params);
      } else {
        this.$store.commit("category/SET_LIST", []);
      }
    },

    // Confirmation of Delete Row
    async deleteSelectedRow(row) {
      try {
        await this.$store.dispatch("inventory/destroy", row);
        this.$store.dispatch("alerts/success", this.$t("deleted_successfully"));

        this.toggleDeleteModal("close");
      } catch (error) {
        this.$store.dispatch("alerts/error", error.response?.data?.message);
      }
    },
  },
};
</script>
